import useSWR from 'swr';
import { useMemo } from 'react';

import { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetExperience() {
  const URL = endpoints.experience.list;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      experiences: data?.experiences || [],
      experiencesLoading: isLoading,
      experiencesError: error,
      postsValidating: isValidating,
      postsEmpty: !isLoading && !data?.experiences.length,
    }),
    [data?.experiences, error, isLoading, isValidating]
  );

  return memoizedValue;
}
export function useGetWorkExperience() {
  const URL = endpoints.experience.worklist;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher);

  const memoizedValue = useMemo(
    () => ({
      experiencedata: data?.experiencedata || [],
      experiencedataLoading: isLoading,
      experiencedataError: error,
      postsValidating: isValidating,
      experiencedataEmpty: !isLoading && !data?.experiencedata.length,
    }),
    [data?.experiencedata, error, isLoading, isValidating]
  );

  return memoizedValue;
}
